const AlertDayOfMonth = Object.freeze({
  FIRST: 'First',
  FIFTEENTH: 'Fifteenth',
  LAST: 'Last'
})
export default AlertDayOfMonth
// RESERVE BELOW
export type AlertDayOfMonthStrings = typeof AlertDayOfMonth[keyof typeof AlertDayOfMonth]
